import Component from 'components/BgSection/index';
import * as React from 'react';

export default {
  test1() {
    return (
      <div style={{width: 790, margin: '100px auto'}}>
        <Component
          avatarBlock={{
            imgUrl: '#',
            title: 'Татьяна Резникова',
            subtitle:
              'Научный сотрудник РАНХиГС и Центра междисциплинарных исследований человеческого потенциала НЦМУ',
          }}
          mainBlock={{
            title: 'О сужении контекстов употребления',
            content:
              'Исчезновение слов из языка обычно сопровождается сокращением числа контекстов, в которых они могут выступать. Например, прилагательное тягостный в современном языке связано в основном с эмоциональным состоянием: тягостными могут быть чувства, переживания, раздумья. Раньше же тягостным называли еще и положение, время, период жизни – сегодня бы мы использовали в этих контекстах слово трудный. Тягостными иногда оказывались даже люди – так говорили про спутников, гостей – сейчас мы бы могли сказать, что эти люди нам в тягость.',
          }}
          bottomCutBlock={{
            title: 'Читать далее',
            content: '...',
          }}
        />
      </div>
    );
  },
};
